import { CommonEntrypoint } from 'entrypoint/CommonEntrypoint';
import 'presentation/style/index.scss';
import ChangePasswordContMain from 'presentation/view/container/ChangePassword/ChangePasswordContMain';

CommonEntrypoint(<ChangePasswordContMain/>)